import { render } from "./AkMessage.vue?vue&type=template&id=0d3cd388"
import script from "./AkMessage.vue?vue&type=script&lang=js"
export * from "./AkMessage.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__